import React from 'react';
import PropTypes from 'prop-types';

import MAP_TYPE from './enums/mapType';
import {layerExists} from './helper-functions/mapbox_helpers';
import {LAYER_SECTIONS_HIGHLIGHTED} from './mapbox-constants/mapbox_constants';
import SeatMapMapboxView from './seatMapMapboxView';

export default class SeatMapClickHandlers extends React.Component {
  static contextTypes = {
    globalRegistry: PropTypes.object,
    router: PropTypes.object,
  };

  processSectionClicked = (firstFeature) => {
    if (firstFeature && firstFeature.properties) {
      const {
        updateQuery,
        sectionIdList,
        multiSectionSelect,
        device,
        setListingSelected,
        seatMapActions,
        actions,
        setStateFromObject,
      } = this.props;

      const previousSectionId = String(sectionIdList);
      const selectedSectionId = String(firstFeature.properties.sectionId);
      if (device === 'phone') {
        setListingSelected(null);
      }

      const queryConfig = {
        listingRows: false,
        zoneIdList: null,
        showBYO: false,
        listingId: false,
        byoQuantity: false,
      };

      if (previousSectionId === selectedSectionId) {
        queryConfig.sectionIdList = null;
        setStateFromObject({
          sectionClicked: false,
          rowCenteredOnMap: false,
          rowClickedFromList: null,
        });
        if (!actions.isMapMoved()) {
          seatMapActions.removeResetControl();
        }
      } else if (multiSectionSelect) {
        let list = [];

        if (previousSectionId && previousSectionId !== 'undefined') {
          list = list.concat(previousSectionId.split(','));
        }

        if (!list.includes(selectedSectionId)) {
          list.push(selectedSectionId);
        } else {
          list = list.filter((ea) => ea !== selectedSectionId);
        }
        queryConfig.sectionIdList = list;

        setStateFromObject({
          sectionClicked: true,
          rowCenteredOnMap: false,
          rowClickedFromList: null,
        });
        seatMapActions.addResetControl();
      } else {
        queryConfig.sectionIdList = [selectedSectionId];

        setStateFromObject({
          sectionClicked: true,
          rowCenteredOnMap: false,
          rowClickedFromList: null,
        });
        seatMapActions.addResetControl();
      }
      updateQuery(queryConfig);
      seatMapActions.updateRender();
    }
  };

  processZoneClicked = (firstFeature) => {
    if (firstFeature && firstFeature.properties) {
      const {
        updateQuery,
        zoneIdList,
        multiSectionSelect,
        device,
        setListingSelected,
        actions,
        seatMapActions,
        setStateFromObject,
      } = this.props;
      const previousZoneId = String(zoneIdList);
      const selectedZoneId = String(firstFeature.properties.zi);
      if (device === 'phone') {
        setListingSelected(null);
      }
      const queryConfig = {
        sectionIdList: false,
        listingRows: false,
        showBYO: false,
        listingId: false,
        byoQuantity: false,
      };
      if (previousZoneId === selectedZoneId) {
        queryConfig.zoneIdList = [];
        setStateFromObject({
          sectionClicked: false,
          rowCenteredOnMap: false,
          rowClickedFromList: null,
        });
        if (!actions.isMapMoved()) {
          seatMapActions.removeResetControl();
        }
      } else if (multiSectionSelect) {
        let list = [];
        if (previousZoneId && previousZoneId !== 'undefined') {
          list = list.concat(previousZoneId.split(','));
        }

        if (!list.includes(selectedZoneId)) {
          list.push(selectedZoneId);
        } else {
          list = list.filter((ea) => ea !== selectedZoneId);
        }
        queryConfig.zoneIdList = list;

        setStateFromObject({
          sectionClicked: true,
          rowCenteredOnMap: false,
          rowClickedFromList: null,
        });
        seatMapActions.addResetControl();
      } else {
        queryConfig.zoneIdList = [selectedZoneId];
        setStateFromObject({
          sectionClicked: true,
          rowCenteredOnMap: false,
          rowClickedFromList: null,
        });
        seatMapActions.addResetControl();
      }
      updateQuery(queryConfig);
      seatMapActions.updateRender();
    }
  };

  getSectionIdsFromFeatureByZone = (firstFeature) => {
    if (firstFeature && firstFeature.properties && firstFeature.properties.zi) {
      const {seatMapActions} = this.props;
      const {zi} = firstFeature.properties;

      return seatMapActions.getSectionIdsFromZones(parseInt(zi));
    }
  };

  handleSectionMouseMove = (e) => {
    const {availableSections, mapType, mapInstance, seatMapActions, setStateFromObject} = this.props;
    if (layerExists(mapInstance, LAYER_SECTIONS_HIGHLIGHTED)) {
      const firstFeature = e && e.features && e.features.length && e.features[0];
      const sectionId =
        firstFeature && firstFeature.properties && firstFeature.properties.sectionId
          ? firstFeature.properties.sectionId
          : null;
      if (sectionId && Array.isArray(availableSections) && availableSections.includes(sectionId)) {
        if (mapType === MAP_TYPE.ZONE) {
          setStateFromObject({
            hoveredSections: this.getSectionIdsFromFeatureByZone(firstFeature),
          });
        } else {
          setStateFromObject({hoveredSections: [sectionId]});
        }
      } else {
        setStateFromObject({hoveredSections: []});
      }

      mapInstance.getCanvas().style.cursor = 'pointer';
      if (Array.isArray(availableSections) && !availableSections.includes(sectionId)) {
        mapInstance.getCanvas().style.cursor = 'move';
      }
      seatMapActions.updateRender();
    }
  };

  handleSectionMouseLeave = () => {
    const {setStateFromObject, seatMapActions} = this.props;
    setStateFromObject({hoveredSections: []});
    seatMapActions.updateRender();
  };

  render() {
    return (
      <SeatMapMapboxView
        {...this.props}
        processSectionClicked={this.processSectionClicked}
        processZoneClicked={this.processZoneClicked}
        handleSectionMouseLeave={this.handleSectionMouseLeave}
        handleSectionMouseMove={this.handleSectionMouseMove}
      />
    );
  }
}

SeatMapClickHandlers.propTypes = {
  /** The actions object. */
  actions: PropTypes.object,

  /** The array of available sections. */
  availableSections: PropTypes.array,

  /** The device type. */
  device: PropTypes.string,

  /** The map instance. */
  mapInstance: PropTypes.object,

  /** The map type. */
  mapType: PropTypes.string,

  /** Whether multiple sections can be selected. */
  multiSectionSelect: PropTypes.bool,

  /** The seat map actions object. */
  seatMapActions: PropTypes.shape({
    /** The function to add the reset control. */
    addResetControl: PropTypes.func,

    /** The function to get the section IDs from the zones. */
    getSectionIdsFromZones: PropTypes.func,

    /** The function to remove the reset control. */
    removeResetControl: PropTypes.func,

    /** The function to update the render. */
    updateRender: PropTypes.func,
  }),

  /** The array of selected section IDs. */
  sectionIdList: PropTypes.array,

  /** The function to set the selected listing. */
  setListingSelected: PropTypes.func,

  /** The function to set the state from an object. */
  setStateFromObject: PropTypes.func,

  /** The function to update the query. */
  updateQuery: PropTypes.func,

  /** The array of selected zone IDs. */
  zoneIdList: PropTypes.array,
};
